import axios from "axios";

//const API_BASE = "http://tse-consultant-int-app.runasp.net/api/Auth";
const API_BASE = "/api/Auth";

export const loginRequest = async (email, password) => {
  console.log("📤 Tentative de login:", email);
  console.log("🔗 API URL:", `${API_BASE}/login`);
  
  try {
    const res = await axios.post(`${API_BASE}/login`, {
      Username: email,
      Password: password
    });
    
    console.log("✅ Login réussi:", res.data);
    return res.data;
    
  } catch (err) {
    console.error("❌ Login error:", err);
    console.error("📋 Response data:", err.response?.data);
    
    let errorMessage = "Email ou mot de passe incorrect";
    
    if (err.response?.data) {
      const data = err.response.data;
      
      if (typeof data === 'object' && data.message) {
        errorMessage = data.message;
      }
      else if (typeof data === 'object' && data.Error) {
        errorMessage = data.Error;
      }
      else if (typeof data === 'string') {
        errorMessage = data;
      }
      else if (typeof data === 'object') {
        errorMessage = JSON.stringify(data);
      }
    }
    
    console.error("🔴 Message d'erreur final:", errorMessage);
    throw new Error(errorMessage);
  }
};

export const registerRequest = async (userData) => {
  console.log("📤 Sending registration:", userData);
  console.log("🔗 API URL:", `${API_BASE}/register`); 
  
  try {
    const payload = {
      FirstName: userData.prenom,
      LastName: userData.nom,
      Email: userData.email,
      Mobile: userData.mobile || "00000000",
      Mp: userData.Mp
    };
    
    console.log("📦 Payload:", payload);
    
    const res = await axios.post(`${API_BASE}/register`, payload);
    
    console.log("✅ Registration success:", res.data);
    return res.data;

  } catch (err) {
    console.error("❌ Registration error:", err);
    console.error("📋 Response data:", err.response?.data);
    
    let errorMessage = "Inscription échouée";
    
    if (err.response?.data) {
      const data = err.response.data;
      
      if (typeof data === 'object' && data.message) {
        errorMessage = data.message;
      } else if (typeof data === 'string') {
        errorMessage = data;
      } else if (typeof data === 'object') {
        errorMessage = JSON.stringify(data);
      }
    }
    
    console.error("🔴 Message d'erreur final:", errorMessage);
    throw new Error(errorMessage);
  }
};

export const forgotPasswordRequest = async (email) => {
  const url = `${window.location.origin}/reset-password`;

  console.log("📤 Forgot password request:");
  console.log("   Email:", email);
  console.log("   Reset URL:", url);
  console.log("   API endpoint:", `${API_BASE}/forgot-password`); // ⬅️ Debug

  try {
    const res = await axios.post(`${API_BASE}/forgot-password`, { 
      Email: email, 
      Url: url 
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log("✅ Forgot password response:", res.data);

    if (typeof res.data === "string") {
      return { success: true, message: res.data };
    }

    return { success: true, message: res.data.message || res.data };

  } catch (err) {
    console.error("❌ Forgot password error:", err);
    console.error("❌ Error details:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status
    });
    
    const message =
      err.response?.data?.message ||
      err.response?.data ||
      err.message ||
      "Erreur lors de la demande de réinitialisation";
    
    throw new Error(message);
  }
};

export const resetPasswordRequest = async (token, newPassword) => {
  console.log("📤 Reset password request");
  console.log("   Token length:", token?.length);
  console.log("   API endpoint:", `${API_BASE}/reset-password`); 
  
  try {
    const res = await axios.post(`${API_BASE}/reset-password`, {
      Token: token,
      NewPassword: newPassword,
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log("✅ Reset password response:", res.data);

    if (typeof res.data === "string") {
      return { success: true, message: res.data };
    }

    return { success: true, message: res.data.message || res.data };

  } catch (err) {
    console.error("❌ Reset password error:", err);
    console.error("❌ Error details:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status
    });

    const message =
      err.response?.data?.message ||
      err.response?.data ||
      err.message ||
      "Impossible de réinitialiser le mot de passe";

    throw new Error(message);
  }
};